export default __webpack_public_path__ + "static/media/sperator-purple.a5b7bf5d.svg";